import { IVehicleWarningsAPIState } from "../types/vehicleWarnings.types";

export const VEHICLE_WARNINGS_INITIAL_STATE: IVehicleWarningsAPIState = {
  data: {
    list: [],
    totalPages: 0,
    totalRecords: 0,
  },
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  list: [],
  loading: false,
  error: null,
  currentScreen: "list",
  selectedVehicleWarning: null,
};
